import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { URL_MAIN_PAGE, URL_PAGE_CATALOG } from '@shared/contants'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function BlogEmpty () {
  const { t: tc } = useTranslation('common')
  const { t: tb } = useTranslation('blog')
  const isTablet = useMediaQuery('(max-width: 991px)')

  return (
    <div className={styles.empty}>
      <h3 className={styles.empty__title}>{tb('empty')}</h3>
      <div className={styles.empty__group}>
        <Button to={URL_MAIN_PAGE} size={!isTablet ? 'large' : 'medium'}>
          {tc('main.back.button')}
        </Button>
        <Button
          to={URL_PAGE_CATALOG}
          size={!isTablet ? 'large' : 'medium'}
          theme="secondary"
        >
          {tc('button.catalog')}
        </Button>
      </div>
    </div>
  )
}
